import { useState } from 'react';

interface FAQItemProps {
  question: string;
  answer: string;
}

function FAQItem({ question, answer }: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="rounded-xl border border-[#1f2937] bg-[radial-gradient(circle_at_top_left,rgba(15,23,42,0.9),#020617)] overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full text-left px-3.5 py-3 border-none bg-transparent text-[0.95rem] font-medium cursor-pointer text-[#e5e7eb] hover:bg-[rgba(148,163,184,0.05)] transition-colors"
      >
        {question}
      </button>
      <div
        className={`overflow-hidden transition-all duration-200 ${
          isOpen ? 'max-h-[500px] pb-3' : 'max-h-0'
        }`}
      >
        <p className="px-3.5 text-[0.9rem] text-[#cbd5f5] m-0">{answer}</p>
      </div>
    </div>
  );
}

export default function FAQ() {
  const faqs = [
    {
      question: 'É seguro usar a plataforma?',
      answer: 'Sim. O acesso à sua conta é protegido por autenticação, as sessões decorrem em área privada e aplicamos medidas técnicas e organizativas para proteger os dados. Além disso, só usamos os seus dados para operação do serviço, faturação e cumprimento legal.'
    },
    {
      question: 'Como funciona o consumo de minutos?',
      answer: 'Os minutos são debitados durante a conversa e o mesmo saldo pode ser usado com qualquer consultor disponível. Quando o saldo termina, a sessão não continua sem novo carregamento.'
    },
    {
      question: 'Posso mudar de consultor sem perder saldo?',
      answer: 'Sim. O saldo é único e partilhado entre os consultores, por isso pode alternar sempre que quiser sem comprar um novo pacote só para trocar de estilo.'
    },
    {
      question: 'Quais métodos de pagamento estão disponíveis?',
      answer: 'De momento pode pagar por MB WAY e Referência Multibanco. Após confirmação do pagamento, os minutos são creditados na sua conta para utilização imediata.'
    },
    {
      question: 'Recebo comprovativo da compra?',
      answer: 'Sim. Sempre que inicia um pagamento e quando este fica concluído, recebe comunicação por email com os dados essenciais da operação.'
    },
    {
      question: 'Em quanto tempo recebo resposta no chat?',
      answer: 'As respostas são, em regra, imediatas. Em períodos de maior utilização podem existir pequenas variações, mas o serviço está desenhado para resposta rápida e contínua.'
    },
    {
      question: 'Este serviço substitui aconselhamento profissional?',
      answer: 'Não. O Tarot Virtual tem natureza de entretenimento e orientação pessoal. Não substitui aconselhamento médico, psicológico, jurídico ou financeiro.'
    },
    {
      question: 'Posso apagar a minha conta e exercer direitos de privacidade?',
      answer: 'Sim. Pode solicitar acesso, retificação, limitação, oposição e eliminação dos seus dados nos termos do RGPD, sem prejuízo das obrigações legais de conservação aplicáveis.'
    }
  ];

  return (
    <section id="faq" className="py-[60px] bg-[#020617] border-t border-b border-[#111827]">
      <div className="max-w-[1120px] mx-auto px-4">
        <h2 className="text-[1.8rem] mb-6 font-bold text-[#e5e7eb]">Perguntas frequentes</h2>
        <div className="flex flex-col gap-2 mt-4">
          {faqs.map((faq, index) => (
            <FAQItem key={index} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </div>
    </section>
  );
}
